module.exports = __webpack_public_path__ + "img/Skirt-Front-B2-Db-Fc-Gb-Hc-Ia.ed1e4c34.png";